import {
  axiosDelete,
  axiosGet,
  axiosPost,
  axiosPut,
  axiosPatch,
} from '../plugins/axios.plugins';
import { getDataApiVersion } from '../utils/helpers';

const API_ENDPOINTS = {
  GET_ALL_CUSTOME_DB_BASEURL: `${process.env.VUE_APP_DATA_API}`,
  DATA_API_BASE_URL: `${process.env.VUE_APP_DATA_API_BASE_URL}`,
};
const updateTableSchema = async (
  user,
  tableName,
  formData,
  updateFieldName
) => {
  const url = `${process.env.VUE_APP_DATA_API}/user-tables/${tableName}/table-schema/${updateFieldName}`;

  let myHeaders = new Headers();
  myHeaders.append(
    'Authorization',
    'Bearer ' + user.signInUserSession.accessToken.jwtToken
  );

  const res = await fetch(url, {
    body: formData,
    headers: myHeaders,
    method: 'PUT',
  });
  return res.json();
};

const getUserDatabases = () => {
  return axiosGet(`${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables`);
};

const getTableItems = (tableName) => {
  return axiosGet(
    `${API_ENDPOINTS.DATA_API_BASE_URL}/${getDataApiVersion(
      tableName
    )}/user-tables/${tableName}/items`
  );
};

const getDataBaseAccessRights = (databaseID) => {
  return axiosGet(
    `${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables/${databaseID}/iam`
  );
};

const shareDataBaseTable = (databaseID, payload) => {
  return axiosPut(
    `${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables/${databaseID}/share`,
    payload,
    { customNotFoundRedirect: true }
  );
};

const getDataBaseTableSchema = async (
  dbName,
  customNotFoundRedirect = false
) => {
  return axiosGet(
    `${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables/${dbName}/table-schema`,
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};

const addTableItem = (tableName, payload) => {
  return axiosPost(
    `${API_ENDPOINTS.DATA_API_BASE_URL}/${getDataApiVersion(
      tableName
    )}/user-tables/${tableName}/items`,
    payload
  );
};

const updateTableItem = (tableName, payload) => {
  return axiosPut(
    `${API_ENDPOINTS.DATA_API_BASE_URL}/${getDataApiVersion(
      tableName
    )}/user-tables/${tableName}/items`,
    payload
  );
};

const deleteDatabaseApi = (databaseName) => {
  return axiosDelete(
    `${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables/${databaseName}`
  );
};

const leaveDatabaseApi = (databaseName, payload) => {
  return axiosDelete(
    `${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables/${databaseName}/share`,
    payload
  );
};

const updateDatabaseItemKey = (databaseName, itemID, key, payload) => {
  return axiosPatch(
    `${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables/${databaseName}/items/${itemID}/${key}`,
    payload
  );
};

export {
  updateTableSchema,
  getUserDatabases,
  getTableItems,
  getDataBaseAccessRights,
  shareDataBaseTable,
  getDataBaseTableSchema,
  addTableItem,
  updateTableItem,
  deleteDatabaseApi,
  leaveDatabaseApi,
  updateDatabaseItemKey,
};
